import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/announcement'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(announcement) {
    return http.post(`${resource}`, announcement)
  },
  update(announcement, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, announcement)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
